import { BackInStockNotificationController } from '@ori/back-in-stock-notification';
import { ServiceUrlsProvider } from '@ori/configuration-manager';
import { EnvironmentProvider } from '@ori/environment';
import { TranslationsProvider } from '@ori/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const App = ({
  currentLanguage,
  globalApiUrl,
  graphqlNetUrl,
  staticApiUrl,
  tenant
}) => /*#__PURE__*/_jsx(ServiceUrlsProvider, {
  serviceUrls: {
    globalApiUrl,
    graphQlNetUrl: graphqlNetUrl,
    staticApiUrl
  },
  children: /*#__PURE__*/_jsx(EnvironmentProvider, {
    tenant: tenant,
    children: /*#__PURE__*/_jsx(TranslationsProvider, {
      defaultTranslationsWithNamespaces: {},
      language: currentLanguage,
      translationsWithNamespaces: {},
      children: /*#__PURE__*/_jsx(BackInStockNotificationController, {})
    })
  })
});